import type { LeadPayload } from "../types";

export interface ApiResponse<T = unknown> {
  code: number;
  message: string;
  data?: T;
}

export class ApiClient {
  private base: string;
  constructor(apiBase: string) { this.base = apiBase.replace(/\/+$/, ""); }

  private async request<T>(path: string, opts: { method?: string; body?: unknown } = {}): Promise<ApiResponse<T>> {
    const url = `${this.base}${path}`;
    const headers: Record<string, string> = { Accept: "application/json" };
    if (opts.body) headers["Content-Type"] = "application/json";
    const res = await fetch(url, { method: opts.method || "GET", headers, body: opts.body ? JSON.stringify(opts.body) : undefined });
    const text = await res.text();
    try { return JSON.parse(text) as ApiResponse<T>; } catch { throw new Error(`Invalid server response (${res.status})`); }
  }

  submitLead(payload: LeadPayload): Promise<ApiResponse> { return this.request("/widget/lead", { method: "POST", body: payload }); }
  sendHeartbeat(visitorId: string, widgetId: string): Promise<ApiResponse> { return this.request("/widget/heartbeat", { method: "POST", body: { visitorId, widgetId } }); }
  requestCallback(phone: string, code: string, widgetId: string): Promise<ApiResponse> { return this.request("/widget/callback", { method: "POST", body: { widgetId, phone, code } }); }
  requestVoiceCall(phone: string, agentId: string, widgetId: string): Promise<ApiResponse> { return this.request("/widget/voice-call", { method: "POST", body: { widgetId, phone, agentId } }); }
}
